import { createAction } from 'redux-actions';
export const SET_SELECTED_REASON = 'REFUND/SET_SELECTED_REASON ';
export const setSelectedReason = createAction(SET_SELECTED_REASON);
